if (!customElements.get('purchased-with')) {
  customElements.define(
    'purchased-with',
    class PurchasedWith extends HTMLElement {
      connectedCallback() {
        this.priceOutput = this.querySelector('[data-purchased-with-price]');
        this.descriptionOutput = this.querySelector('[data-purchased-with-description]');
        this.hiddenInput = this.querySelector('[data-purchased-with-hidden-input]');
        this.inputs = this.querySelectorAll('[data-purchased-with-input]');

        this.bindEvents();
        this.resetContent();
      }

      bindEvents() {
        this.inputs.forEach((input) => {
          input.addEventListener('change', this.handleInputChange.bind(this));
        });
      }

      handleInputChange(event) {
        const input = event.currentTarget;

        if (!input.checked) return;

        this.updateHiddenInput(input);
        this.updatePrice(input);
        this.updateDescription(input);
        this.clearFormError();
      }

      clearFormError() {
        const section = this.closest('.shopify-section') || this.closest('product-info');
        section?.querySelector('product-form')?.handleErrorMessage?.();
      }

      updateHiddenInput(input) {
        if (!this.hiddenInput) return;

        this.hiddenInput.value = input.value || '';
      }

      updatePrice(input) {
        if (!this.priceOutput) return;

        const price = input.dataset.productPrice || '';

        this.priceOutput.textContent = price;
        this.priceOutput.hidden = !price;
      }

      updateDescription(input) {
        if (!this.descriptionOutput) return;

        const item = input.closest('[data-purchased-with-item]');
        const template = item?.querySelector('[data-purchased-with-description-template]');
        const description = this.getFirstParagraph(template);

        this.descriptionOutput.innerHTML = description;
        this.descriptionOutput.hidden = !description;
      }

      getFirstParagraph(template) {
        if (!template) return '';

        const content = template.content?.cloneNode(true);
        const firstParagraph = content?.querySelector('p');

        if (firstParagraph) {
          return firstParagraph.outerHTML.trim();
        }

        const text = template.innerHTML?.trim();

        if (!text) return '';

        return `<p>${text}</p>`;
      }

      resetContent() {
        const checkedInput = this.querySelector('[data-purchased-with-input]:checked');

        if (checkedInput) {
          this.updateHiddenInput(checkedInput);
          this.updatePrice(checkedInput);
          this.updateDescription(checkedInput);
          return;
        }

        if (this.hiddenInput) {
          this.hiddenInput.value = '';
        }

        if (this.priceOutput) {
          this.priceOutput.textContent = '';
          this.priceOutput.hidden = true;
        }

        if (this.descriptionOutput) {
          this.descriptionOutput.innerHTML = '';
          this.descriptionOutput.hidden = true;
        }
      }
    }
  );
}
